import type { ReactNode } from "react";

interface ContentCardProps {
  children: ReactNode;
  className?: string;
  size?: 'none' | 'sm' | 'md' | 'lg';
  header?: ReactNode;
  headerClassName?: string;
  'data-testid'?: string;
}

const padding = {
    none: '',
    sm: 'gap-2 p-1',
    md: 'gap-4 p-2',
    lg: 'gap-6 p-3.5'
}

export const ContentCard = ({
                                children, size = "lg", className = "", header,
                                headerClassName = "border-t-gray-200",
                                'data-testid': dataTestId
                            }: ContentCardProps) => {
  const baseClasses = "border border-gray-200 rounded-lg box-border flex flex-col size-full";
    const defaultHeaderClasses = "border-t-4 px-5 py-3";

  return (
    <div className={`${baseClasses} ${className}`} data-testid={dataTestId}>
      {header && (
        <header className={`${defaultHeaderClasses} ${headerClassName}`}>
          {header}
        </header>
      )}
      <div className={`${padding[size]} flex flex-col`}>
        {children}
      </div>
    </div>
  );
};